import { DEFAULT_STATUS_VARIANT, STATUS_CODE_VARIANT_MAP, STATUS_CONFIG } from './statusConstants';

/**
 * Derive the variant key for a given status code.
 */
export function getStatusVariantByCode(code) {
  const normalized = Number(code);
  if (Number.isNaN(normalized)) {
    return DEFAULT_STATUS_VARIANT;
  }
  return Object.prototype.hasOwnProperty.call(STATUS_CODE_VARIANT_MAP, normalized)
    ? STATUS_CODE_VARIANT_MAP[normalized]
    : DEFAULT_STATUS_VARIANT;
}

/**
 * Retrieve the display label for a given status code.
 */
export function getStatusLabelByCode(code) {
  const variant = getStatusVariantByCode(code);
  return STATUS_CONFIG[variant]?.label || STATUS_CONFIG[DEFAULT_STATUS_VARIANT].label;
}
